import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './GraciasPage.css';

/**
 * Página de confirmación después de votar
 * Muestra mensaje de éxito y opciones de navegación
 */
const GraciasPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const encuestaTitulo = location.state?.encuestaTitulo || 'la encuesta';

  useEffect(() => {
    // Scroll al inicio
    window.scrollTo(0, 0);
  }, []);

  const handleCompartir = () => {
    const url = window.location.origin;
    
    if (navigator.share) {
      navigator.share({
        title: 'Plaza Express - Encuestas Anónimas',
        text: `Acabo de participar en ${encuestaTitulo}. ¡Tú también puedes participar!`,
        url: url,
      }).catch(() => {
        // Si falla, copiar al portapapeles
        copiarAlPortapapeles(url);
      });
    } else {
      // Fallback: copiar al portapapeles
      copiarAlPortapapeles(url);
    }
  };

  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch(() => {
      // Fallback más antiguo
      const textarea = document.createElement('textarea');
      textarea.value = texto;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      alert('¡Enlace copiado al portapapeles!');
    });
  };

  return (
    <div className="gracias-page">
      <div className="gracias-container">
        <div className="gracias-content">
          <div className="gracias-icon">✓</div>
          
          <h1 className="gracias-titulo">¡Gracias por tu participación!</h1>
          
          <p className="gracias-mensaje">
            Tu voto ha sido registrado exitosamente. Tu opinión es muy valiosa para nosotros.
          </p>

          <div className="gracias-info">
            <div className="info-item">
              <span className="info-icon">🔒</span>
              <span className="info-text">Tu participación es completamente anónima</span>
            </div>
            <div className="info-item">
              <span className="info-icon">📊</span>
              <span className="info-text">Los resultados estarán disponibles en el panel de administración</span>
            </div>
          </div>

          <div className="gracias-actions">
            <button
              className="btn-compartir"
              onClick={handleCompartir}
            >
              📤 Compartir Plaza Express
            </button>
            
            <button
              className="btn-inicio"
              onClick={() => navigate('/')}
            >
              Ver otras encuestas
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraciasPage;

